/**
 * Canonical top-of-page stat card (left-border accent, ADR-033 idiom).
 * Accent carries the state: emerald=good, amber=attention, blue=info,
 * border=neutral.
 */
export function StatCard({
  label,
  value,
  accent,
  secondary,
  secondaryClass,
}: {
  label: string;
  value: string;
  accent: string;
  secondary?: string;
  secondaryClass?: string;
}) {
  return (
    <div className={`bg-card border-l-3 ${accent} rounded-r-lg pl-4 pr-5 py-3`}>
      <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap">
        {label}
      </div>
      <div className="text-lg font-bold tabular-nums">{value}</div>
      {secondary && (
        <div className={`text-xs ${secondaryClass ?? "text-muted-foreground"}`}>{secondary}</div>
      )}
    </div>
  );
}
